import React from 'react';

import styles from './divider.scss';

interface Props {
  additionalStyles?: string;
}
export const Divider: React.FC<Props> = ({ additionalStyles }) => (
  <div className={additionalStyles ? `${styles.divider} ${additionalStyles}` : styles.divider} />
);
